import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Icons from '../../assets/images/index';
import _ from 'underscore';
import ReactPaginate from 'react-paginate';
import { message, options, pagination, PaginationOption } from "../../components/common/utils/message";
import { alert, confirm } from "react-bootstrap-confirmation";
import { useDispatch } from "react-redux";
import SelectBox from "../../components/common/formInput/SelectBox";
import { listOwnerType, deleteOwnerType, updateOwnerTypeStatus } from '../../services/ownerType';
import { success } from '../../components/common/Toastify';
import { _status } from '../../components/common/utils/message';

const OwnerTypeList = () => {
    const dispatch = useDispatch();

    const [resPayload, setResPayload] = useState();
    const [searchKey, setSearchKey] = useState("");
    const [searchBystatus, setSearchByStatus] = useState();

    const totalPages = resPayload && resPayload.totalPages;

    const [limit, setLimit] = useState(pagination.limit);
    const [page, setPage] = useState(pagination.page)

    useEffect(() => {
        _getListing();
    }, [dispatch]);

    /**
     * @description get all the contractors from db where page is pageChange and Limit for limit of the data.
     */
    const _getListing = () => {
        listOwnerType({ page, limit }, (data) => {
            setResPayload(data)
        }, dispatch)
    }

    /**
   * @description Function For delete RPC.
   * @param {id} id 
   */
    const _handleDelete = async (id) => {
        const result = await confirm(message.deleteData, options);
        if (result) {
            deleteOwnerType(id, async res => {
                if (res.status === "SUCCESS" && res.code === 200) {
                    _getListing();
                    success(res.message);
                    await alert(message.OwnerTypeDeleted);
                }
            })
        }
    }

    /**
     * @description /Function is on Page Change.
     * @param {param} param 
     */
    const handlePageChange = async (param) => {
        let currentPage = param.selected + 1;
        setPage(currentPage)
        await listOwnerType({ page: currentPage, limit }, response => {
            setResPayload(response);
        }, dispatch)
    };

    /**
   * @description Function for show in dropdown entries with page option.
   * @param {param} displayPerPage 
   */
    const setPagination = async (displayPerPage) => {
        setLimit(displayPerPage);
        await listOwnerType({ limit: displayPerPage, page }, response => {
            setResPayload(response);
        }, dispatch)
    }

  /**
   * @description Function on Toggle status Change. 
   * @param {id} id 
   */
   const _handleStatus = (item, status) => {
    updateOwnerTypeStatus({ id: item._id, status: status }, res => {
        if (res.status === "SUCCESS" && res.code === 200) {
            _getListing();
            success(res.message);
        }
    }, dispatch)
}

    /**
  * @description Function for filter data with status fields.
  * @param {param} filterParam 
  */
    const onStatusSearch = async (filterParam) => {
        setSearchByStatus(filterParam);
        let newParam = true;
        if (filterParam === 'Active') newParam = true
        if (filterParam === 'Inactive') newParam = false
        await listOwnerType({ limit, page, fields: "status", extraFilter: newParam }, response => {
            setResPayload(response);
        }, dispatch)
    }
    return (
        <div className='dashboard-inner'>
            <div className="d-h-wrap">
                <div className="d-h-l">
                    <div className="custom-seachbox">
                        <input type="search" placeholder="Search" onChange={(e) => setSearchKey(e.target.value)} />
                        <button className="btn btn-primary btn-search">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.11109 15.2222C12.0384 15.2222 15.2222 12.0384 15.2222 8.11109C15.2222 4.18374 12.0384 1 8.11109 1C4.18374 1 1 4.18374 1 8.11109C1 12.0384 4.18374 15.2222 8.11109 15.2222Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17.0004 17L13.1338 13.1333" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div className="d-h-r">
                    <ul className="dashboard-sub-filters">
                        <li>
                            <div className="sortby">
                                <span>Sort by : </span>
                                <div className="nocolor-dropdown">
                                    <SelectBox
                                        options={_status.map(item => item.label)}
                                        val={searchBystatus}
                                        handleVal={(e) => onStatusSearch(e)}
                                    />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className='d-card'>
                <div className='d-card-header'>
                    <h5 className='d-card-heading'>Owner Type Management</h5>
                    <div className='d-card-actions'>
                        <Link to={`/owner-type-form`} className='btn btn-blue'>Add New Owner Type</Link>
                    </div>
                </div>
                <div className='d-card-body p-b-0'>
                    <div className='responsive-table'>
                        <table className='table-odd-even cellSpace15'>
                            <tbody>
                                {resPayload && resPayload.docs
                                    .filter((val) => {
                                        if (searchKey === '') {
                                            return val;
                                        } else if (
                                            val.owner_type_name.toLowerCase().includes(searchKey.toLowerCase())) {
                                            return val;
                                        }
                                    })
                                    .map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className='bid-details blue-bid-details'>
                                                    <Link className='blue-bid-icon' to={`/owner-type-view/${item._id}`} >
                                                        <svg width="22" height="27" viewBox="0 0 22 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.641 0.49963C9.55438 1.10584 0.274134 6.675 0.194425 6.76874C0.136116 6.83723 0.0629188 6.98371 0.0317535 7.09417C-0.0156885 7.2621 -0.0117629 7.33176 0.05569 7.51914C0.10002 7.64235 0.173218 7.77791 0.218362 7.82029C0.29381 7.89117 10.1928 13.801 10.651 14.0486C10.913 14.1903 11.0936 14.1862 11.3802 14.0321C11.8525 13.7781 21.7024 7.89655 21.7816 7.8212C21.8268 7.77832 21.9 7.64235 21.9443 7.51914C22.0118 7.33176 22.0157 7.2621 21.9682 7.09417C21.9371 6.98371 21.8639 6.83682 21.8056 6.76772C21.7195 6.6657 12.1918 0.95036 11.3802 0.513806C11.0976 0.361835 10.8949 0.357923 10.641 0.49963ZM1.60758 11.9906C0.904715 12.414 0.274373 12.8161 0.206777 12.8841C-0.0547527 13.1474 -0.0503485 13.6463 0.215872 13.9151C0.288687 13.9886 1.03766 14.4588 1.88022 14.9599C2.72278 15.4609 4.99186 16.812 6.92267 17.9622C8.85343 19.1125 10.5168 20.0988 10.6189 20.1542C10.8603 20.2848 11.1452 20.2818 11.3969 20.146C11.5077 20.0861 13.0956 19.1452 14.9256 18.0551C16.7555 16.9649 19.0175 15.6174 19.9522 15.0607C20.8869 14.5041 21.7113 13.9884 21.7841 13.915C21.9576 13.74 22.0299 13.4562 21.9655 13.2025C21.9386 13.0964 21.8569 12.9492 21.7841 12.8755C21.7113 12.8017 21.0723 12.3962 20.364 11.9744L19.0762 11.2074L15.495 13.3403C13.5252 14.5134 11.8104 15.5129 11.6842 15.5614C11.3703 15.6823 10.6296 15.6822 10.3157 15.5614C10.1894 15.5129 8.49831 14.5268 6.55764 13.3702C4.61697 12.2136 2.99685 11.2568 2.95736 11.244C2.91786 11.2313 2.31045 11.5672 1.60758 11.9906ZM5.00436 13.6493C5.51186 13.9777 5.45924 14.7486 4.91292 14.9889C4.50389 15.1688 4.08486 14.9441 3.96767 14.482C3.80844 13.8546 4.48355 13.3123 5.00436 13.6493ZM17.6448 13.6193C18.1091 13.8757 18.195 14.4578 17.8261 14.8492C17.3987 15.3029 16.6487 14.9626 16.6492 14.3152C16.6496 13.7554 17.1976 13.3724 17.6448 13.6193ZM8.03092 15.5169C8.61062 15.826 8.50616 16.7603 7.87304 16.929C7.40944 17.0524 6.91194 16.5581 6.99979 16.0612C7.01659 15.966 7.08769 15.8158 7.15772 15.7275C7.38943 15.4352 7.72569 15.3541 8.03092 15.5169ZM14.6767 15.5652C14.9088 15.749 14.9976 15.9255 14.9938 16.1951C14.9878 16.6256 14.6972 16.9267 14.2878 16.9267C13.5447 16.9267 13.3081 15.8778 13.9691 15.514C14.1739 15.4013 14.4997 15.4248 14.6767 15.5652ZM11.3056 17.2767C11.549 17.3846 11.6942 17.6368 11.6942 17.9519C11.6942 18.3873 11.4013 18.7051 11 18.7051C10.5987 18.7051 10.3058 18.3873 10.3058 17.9519C10.3058 17.3871 10.8008 17.0528 11.3056 17.2767ZM1.59298 18.122C0.882071 18.544 0.252735 18.9453 0.194425 19.0138C0.136116 19.0823 0.0629188 19.2288 0.0317535 19.3392C-0.0156885 19.5071 -0.0117629 19.5768 0.05569 19.7642C0.10002 19.8874 0.173218 20.023 0.218362 20.0655C0.293618 20.1364 10.1898 26.0442 10.651 26.2937C10.913 26.4354 11.0936 26.4313 11.3802 26.2772C12.1918 25.8406 21.7195 20.1253 21.8056 20.0233C21.8639 19.9542 21.9371 19.8073 21.9682 19.6968C22.0157 19.5289 22.0118 19.4592 21.9443 19.2718C21.9 19.1486 21.8268 19.013 21.7816 18.9705C21.6704 18.8658 19.1424 17.3586 19.0779 17.3586C19.0498 17.3586 18.551 17.6421 17.9695 17.9886C17.3881 18.3351 15.7939 19.285 14.4269 20.0995C13.06 20.914 11.8166 21.6251 11.6638 21.6797C11.326 21.8005 10.7384 21.8118 10.3968 21.7041C10.1515 21.6268 9.55079 21.2782 5.45149 18.8334C4.12694 18.0435 3.00777 17.3877 2.9644 17.376C2.92102 17.3644 2.3039 17.7001 1.59298 18.122Z" fill="white" />
                                                        </svg>
                                                    </Link>
                                                    <h4>{item.owner_type_name}</h4>
                                                </div>
                                            </td>
                                            <td className='text-right'>
                                                <label htmlFor={`toggleSwitch01${index + 1}`} className='toggle-switch m-r-10'>
                                                    <input type="checkbox" id={`toggleSwitch01${index + 1}`}
                                                        name={`status`}
                                                        value={Number(item.status)}
                                                        defaultChecked={item.status}
                                                        onChange={(val) => { _handleStatus(item, val.currentTarget.checked) }} />
                                                    {item.status ? <h6 className='deactivate'>Active</h6> : <h6 className='activate'>Inactive</h6>}
                                                    <span className='toggle-bar'></span>
                                                </label>
                                                <Link className="dashboard-action" title="Edit" to={`/owner-type-form?id=${item._id}`}>
                                                    <img src={Icons.edit} alt="" height="20px" />
                                                </Link>
                                                <button className="dashboard-action" title="Delete" onClick={() => _handleDelete(item._id)}>
                                                    <img src={Icons.bin} alt="" height="20px" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="table-filters">
                        <div className="t-f-cell">
                            <div className="records-filter">
                                <span>Show</span>
                                <div className="grey-dropdown bg-white">
                                    <SelectBox
                                        options={PaginationOption}
                                        val={limit}
                                        handleVal={(e) => setPagination(e)}
                                    />
                                </div>
                                <span>Entries</span>
                            </div>
                        </div>
                        {totalPages > 1 ? (
                            <div className="t-f-cell">
                                <ReactPaginate
                                    breakLabel={"..."}
                                    nextLabel={'Next >'}
                                    onPageChange={handlePageChange}
                                    pageCount={totalPages}
                                    previousLabel={'< Back'}
                                    renderOnZeroPageCount={null}
                                    containerClassName={'custom-pagination '}
                                    pageClassName={'btn-page'}
                                    pageLinkClassName={'btn-page'}
                                    previousClassName={'btn-page'}
                                    previousLinkClassName={'btn-previous'}
                                    nextClassName={'btn-page'}
                                    nextLinkClassName={'btn-next'}
                                    activeClassName={'active'}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default OwnerTypeList

